<template>
  <div>
    <div class="input-group mb-3">
      <input v-model="valueHoursModel" type="number"
             class="form-control"
             min="0" max="99"
      >
      <div class="input-group-append">
        <span class="input-group-text">h</span>
      </div>
      <input v-model="valueMinutesModel" type="number"
             class="form-control"
             min="0" max="45"
             step="15"
      >
      <div class="input-group-append">
        <span class="input-group-text">m</span>
      </div>
    </div>
  </div>
</template>

<script>
import DataTypeMixin from 'CORE/mixins/dataType'

export default {
    name: 'IntervalInput',
    mixins: [
        DataTypeMixin,
    ],
    data() {
        return {
            hours: 0,
            minutes: 0,
        }
    },
    computed: {
        valueHoursModel: {
            get() {
                return _.get(this.value, 'value.value.hours', 0)
            },
            set(value) {
                this.hours = value
                this.$emit('input', {value: {value: {hours: this.hours, minutes: this.minutes}}})
            },
        },
        valueMinutesModel: {
            get() {
                return _.get(this.value, 'value.value.minutes', 0)
            },
            set(value) {
                this.minutes = value
                this.$emit('input', {value: {value: {hours: this.hours, minutes: this.minutes}}})
            },
        },
    },
}
</script>
